import Cookies from 'js-cookie';
import { postMessageAction, postMessageService } from './postMessageService';
import { GlobalCfg } from '../../conf';

/**
 * Sends a postMessage to the parent window when authentication expires
 */
export const notifyAuthExpired = (currentPath?: string) => {
    // Only send message if we're in an iframe
    if (window.parent && window.parent !== window) {
        const message = {
            action: postMessageAction.REAUTHENTICATE_AND_REDIRECT,
            url: currentPath || window.location.href,
        };

        try {
            postMessageService.sendToParent(message);
        } catch (error) {
            console.error('Failed to send auth expiration message to parent:', error);
        }
    }
};

/**
 * Cookie monitoring utility to detect when the actor cookie is removed
 */
class CookieMonitor {
    private intervalId: NodeJS.Timeout | null = null;

    private lastCookieValue: string | undefined = undefined;

    start() {
        if (this.intervalId) {
            return; // Already monitoring
        }

        // Initial check
        this.lastCookieValue = Cookies.get(GlobalCfg.CLIENT_AUTH_COOKIE);

        // Check every 1 minute for cookie changes
        this.intervalId = setInterval(() => {
            const currentCookieValue = Cookies.get(GlobalCfg.CLIENT_AUTH_COOKIE);

            // If we had a cookie before but don't have it now, it was removed
            if (this.lastCookieValue && !currentCookieValue) {
                notifyAuthExpired();
            }

            this.lastCookieValue = currentCookieValue;
        }, 60000);
    }

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

// Singleton instance
export const cookieMonitor = new CookieMonitor();

/**
 * Initialize cookie monitoring when the app starts
 */
export const initializeAuthMonitoring = () => {
    cookieMonitor.start();

    // Clean up on page unload
    window.addEventListener('beforeunload', () => {
        cookieMonitor.stop();
    });
};
